import { isAxiosError } from 'axios';
import { refreshTokenRequest } from './authClient';
import { clearTokens, getRefreshToken, notifySessionEnd, setTokens } from './tokenStore';

export class SessionExpiredError extends Error {
  constructor(message = 'Session expired') {
    super(message);
    this.name = 'SessionExpiredError';
  }
}

let inFlightRefresh: Promise<string> | null = null;

const endSession = () => {
  clearTokens();
  notifySessionEnd();
};

const isTransientFailure = (error: unknown) => {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  return status === undefined || status >= 500;
};

export const refreshSession = (): Promise<string> => {
  if (inFlightRefresh) return inFlightRefresh;

  inFlightRefresh = (async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) {
      endSession();
      throw new SessionExpiredError('No refresh token stored');
    }

    try {
      const tokenPair = await refreshTokenRequest(refreshToken);
      setTokens(tokenPair);
      return tokenPair.access_token;
    } catch (error) {
      if (!isTransientFailure(error)) endSession();
      throw error;
    }
  })().finally(() => {
    inFlightRefresh = null;
  });

  return inFlightRefresh;
};
